import { Grid, Text } from '@approvalmax/ui/src/components';
import random from 'lodash/random';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

export const Loading = memo(() => {
    return (
        <Grid gap={8} gridTemplateColumns='max-content auto 24px'>
            <Skeleton width='22px' height='16px' />

            <Grid gap={4}>
                <Text font='label' fontSize='small'>
                    <Skeleton width='50px' height='12px' />
                </Text>

                <Text font='label' fontSize='small'>
                    <Skeleton width={random(30, 100)} height='12px' />
                </Text>
            </Grid>

            <div />
        </Grid>
    );
});

Loading.displayName = 'Loading';
